interface Props {
  address: string
  type: 'address' | 'tx'
  chainID: string
}

const openInFinder = ({ address, type, chainID }: Props) => {
  window.open(
    `https://finder.terra.money/${chainID}/${type}/${address}`,
    '_blank',
  )
}

export default openInFinder
